import { createContext, useContext } from "react";

const NotificationContext = createContext(null);

export function useNotification() {
    return useContext(NotificationContext);
}

export default NotificationContext;
